import {
  targetMarketShareHistoryInterface,
  targetMarketShareInstanceInterface,
} from 'Interfaces/FactsInterfaces/drugInterfaces';

export const checkFutureStrategiesOverlap = (
  startDate: string,
  endDate: string,
  setErrorDetails: (error: { isError: boolean; errorDescription: string }) => void,
  marketHistoricalData: targetMarketShareHistoryInterface
) => {
  const startDateInstance = new Date(startDate);
  const endDateInstance = new Date(endDate);
  let overlapFound = false;
  marketHistoricalData.future_tms_values.forEach(futureDate => {
    const tempStartDate = new Date(futureDate.StartDate);
    const tempEndDate = new Date(futureDate.EndDate);
    if (!(startDateInstance > tempEndDate || tempStartDate > endDateInstance)) {
      setErrorDetails({
        isError: true,
        errorDescription: "Given date range can't be set because it overlaps with future strategy",
      });
      overlapFound = true;
    }
  });
  return overlapFound;
};

export const createDateRangesForOppositeStrategyAndCheckValidity = (
  tms: number,
  StartDate: string,
  EndDate: string,
  cot: string,
  category: 'Direct' | 'Indirect',
  currentTMSData: targetMarketShareInstanceInterface[],
  oppositeStrategyFutureRangesData: targetMarketShareHistoryInterface,
  setErrorDetails: (error: { isError: boolean; errorDescription: string }) => void
) => {
  const rangesData: {
    TargetMarketShare: string;
    StartDate: string;
    EndDate: string;
    sellingCategory: string;
  }[] = [];

  // we need to take values from opposite strategy i.e direct, indirect vice versa and create ranges and their value

  // iterate over future value for opposite strategy and fill in ranges data
  oppositeStrategyFutureRangesData.future_tms_values.forEach(futureRangeData => {
    rangesData.push({
      TargetMarketShare: futureRangeData.TargetMarketShare,
      StartDate: futureRangeData.StartDate,
      EndDate: futureRangeData.EndDate,
      sellingCategory: futureRangeData.SellingCategory,
    });
  });

  // Even we need to iterate over the past ranges, because current one may collide with some past ranges
  oppositeStrategyFutureRangesData.past_tms_values.forEach(futureRangeData => {
    rangesData.push({
      TargetMarketShare: futureRangeData.TargetMarketShare,
      StartDate: futureRangeData.StartDate,
      EndDate: futureRangeData.EndDate,
      sellingCategory: futureRangeData.SellingCategory,
    });
  });

  // we need to find the current value of the that particular COT of opposite strategy
  // for that purpose we will check from the marketShareTable Data

  currentTMSData.forEach(instance => {
    if (instance.COT === cot && instance.SellingCategory !== category) {
      rangesData.push({
        TargetMarketShare: instance.TargetMarketShare,
        StartDate: instance.StartDate,
        EndDate: instance.EndDate,
        sellingCategory: instance.SellingCategory,
      });
    }
  });

  // true represents it is valid
  let validityResult = true;

  const currentStartDate = new Date(StartDate);
  const currentEndDate = new Date(EndDate);

  for (let i = 0; i < rangesData.length; i++) {
    const rangeData = rangesData[i];
    const oppositeStrStartDate = new Date(rangeData.StartDate);
    const oppositeStrEndDate = new Date(rangeData.EndDate);

    // check if the current start date is between the ranges
    if (
      currentStartDate >= oppositeStrStartDate &&
      currentStartDate <= oppositeStrEndDate &&
      tms + parseFloat(rangeData.TargetMarketShare) > 1
    ) {
      validityResult = false;
    }

    if (
      currentEndDate >= oppositeStrStartDate &&
      currentEndDate <= oppositeStrEndDate &&
      tms + parseFloat(rangeData.TargetMarketShare) > 1
    ) {
      validityResult = false;
    }

    if (
      currentStartDate <= oppositeStrStartDate &&
      currentEndDate >= oppositeStrEndDate &&
      tms + parseFloat(rangeData.TargetMarketShare) > 1
    ) {
      validityResult = false;
    }

    if (!validityResult) {
      setErrorDetails({
        isError: true,
        errorDescription: `COT - ${cot}, Strategy - ${rangeData.sellingCategory}, has strategy whose date range collides with current date range and exceedes the TMS sum to more than 100%`,
      });
      break;
    }
  }

  return validityResult;
};
